import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  private BASE_URL = environment.BASE_URL;
  constructor(private http: HttpClient, public router: Router) {}
  async postData(payload) {
    try {
      let result = await this.http
        .post(`${this.BASE_URL}/api/register`, payload)
        .toPromise();
      return result;
    } catch (error) {
      return error;
    }
  }

  async postAntigenData(payload) {
    try {
      let result = await this.http
        .post(`${this.BASE_URL}/api/antigen`, payload)
        .toPromise();
      return result;
    } catch (error) {
      return error;
    }
  }

  async verifyCaptcha(data) {
    try {
      let response = await this.http.post(`${this.BASE_URL}/api/register/verifyCaptcha`, data).toPromise();
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async getDocument(id) {
    try {
      let result = await this.http
        .get(`${this.BASE_URL}/api/register/getReport?id=${id}`, {
          responseType: 'blob',
        })
        .toPromise();
      return result;
    } catch (error) {
      return error;
    }
  }

  async getCompanies() {
    try {
      let result = await this.http
        .get(`${this.BASE_URL}/api/company`)
        .toPromise();
      return result;
    } catch (error) {
      return error;
    }
  }
  
}
